import { createPinia } from 'pinia';

export const piniaPlugin = createPinia();
